<form #newModule (ngSubmit)="submit($event)" class="mt-4 mb-0">
  <div class="fieldset fieldset--lg">
    <p class="text-center text-sm">{{file?.name || 'No File Selected'}}</p>
    <button (click)="mediafile.click()" type="button" id="mediafileLabel" class="btn m-auto">Select
      File</button>
    <input #mediafile (change)="file = mediafile.files[0]; mediatitle = file?.name" type="file" name="mediafile"
      aria-labelledby="mediafileLabel" id="mediafile" class="sr-only" autofocus required>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="title">Title <span class="requiredfield">*</span></label>
    <input type="text" name="title" id="title" class="text-field" [(ngModel)]="mediatitle" required="required">
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button *ngIf="uploading; else notUploading" type="button" class="btn btn--loading m-0">Uploading... {{uploadpercentage}}%</button>
    <ng-template #notUploading>
      <button [disabled]="!selectedFileValid() || submitted" type="submit" class="btn m-0">Upload</button>
    </ng-template>
    <button routerLink="/user/modulemedialibrary"
      [queryParams]="{moduleid: this.moduleid}" type="button" class="btn btn--warning m-0">Cancel</button>
  </div>
</form>
